
import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

import { translations } from './../i18/translations.js';

const SITE_KEY = window.location.hostname === 'mbkegy' ? "6Ld6teUqAAAAADnmtEISNJplsD1aTwmPt6_Sk-ay" : "6LdhpeUqAAAAABvH9dgQJNI3vGYFf1L2okVlXaVM";

const Captcha: React.FC<{ onVerify: (token: string | null) => void }> = ({ onVerify, onCaptchaExpire }) => {

  const {lang} = useOutletContext();
  const [verified, setVerified] = useState(false);

  function handleVerify(token: string | null) {
    if (token) {
      setVerified(true);
      onVerify(token);
    }
  }

  return (
    <div className="flex flex-col items-center p-4 rounded-lg shadow-md">
      <ReCAPTCHA sitekey={SITE_KEY} onChange={handleVerify} onExpired={onCaptchaExpire} />
    </div>
  );
};

export default Captcha;